export default "__VITE_ASSET__DsPWPeyj__"